export default __webpack_public_path__ + "static/media/wexcedo_logo_full_light_mode.f7b42938.png";